<template>
  <div class="box" style="width: 100%; height: 100%">
    <!-- 查询条件区域 -->
    <div
      class="selector-container d-flex align-items-center section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="充值记录" ></SectionTitle>
     <el-form :inline="true" style="text-align: left" size="small">
       <el-form-item label="账号:" :class="{'light-label':skinType}">
           <el-input v-model="input" placeholder="请输入"></el-input>
       </el-form-item>
       <el-form-item>
           <el-button type="primary" @click="chaxun">查询</el-button>
       </el-form-item>
     </el-form>
      <el-button style="margin-left:auto;"
       type="primary" circle icon="iconfont  iconfanhui"
        size="small"
        v-on:click="$router.go(-1)"></el-button>
    </div>
    <div
      class="d-flex flex-column align-items-stretch section-container"
      :class="{ dark: skinType }"
      style="width: 100%; height: 100%"
    >
      <!-- 表格区域 -->
      <div style="overflow-y: auto; width: 100%; height: 100%">
        <el-table  size="small"
                    stripe
          :data="tableData"
          class="table"
          @selection-change="handleSelectionChange"
          :class="{ dark: skinType }"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
        >
          <el-table-column fixed type="index" label="#" width="80">
          </el-table-column>
          <el-table-column prop="TabID" label="ID编号"> </el-table-column>
          <el-table-column prop="FirmID" label="用户账号"> </el-table-column>
          <el-table-column prop="Amount" label="充值金额"> </el-table-column>
          <el-table-column prop="Balance" label="充值后余额"> </el-table-column>
          <el-table-column label="充值日期">
            <template slot-scope="scope">{{
              scope.row.F_CreatorTime
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div
        style="
          display: flex;
          width: 100%;
          justify-content: flex-end;
          padding: 1rem 1rem 1rem 0;
        "
      >
        <div
          v-if="pagetotal"
          style="
            display: flex;
            width: 100%;
            justify-content: flex-end;
            align-items: center;
          "
          class="section-container"
          :class="{ dark: skinType }"
        >
          <el-pagination
            style="margin-left: auto"
            background
            :class="{ 'text-white': skinType }"
            layout="total, prev, pager, next"
            :total="pagetotal"
            :current-page.sync="pageIndex"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/utils/section-title.vue';
import {
  queryRecharge,
} from '@/api/recharge-record/recharge-record';

export default {
  name: 'recharge-record',
  components: {
    SectionTitle,
  },
  data() {
    return {
      input: null,
      tableData: [],
      multipleSelection: [],
      pageIndex: 1,
      pagetotal: 0,
      pageSize: 10,
      num: 1,
    };
  },
  created() {
    // 初始化第一页
    this.requestRechargeList();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestRechargeList() {
      queryRecharge({
        page: this.pageIndex,
        rows: this.pageSize,
        FirmID: this.input,
      })
        .then((res) => {
          this.tableData = res.Rows;
          this.pagetotal = res.TotalRowsCount;
        })
        .catch(() => {
          this.tableData = [];
          this.pagetotal = 0;
        });
    },
    // 点击查询
    chaxun() {
      this.requestRechargeList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>
<style scoped>
.buttonblock {
  line-height: 40px;
  position: relative;
  right: 32%;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.cell {
  text-align: center;
}
</style>
